var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 57,
    viewBox: "0 0 37 57",
    width: 37,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.0092 31.7695c2.086 0 4.1516-.4108 6.0789-1.2091 1.9272-.7983 3.6783-1.9684 5.1534-3.4434 1.475-1.4751 2.6451-3.2262 3.4434-5.1534.7983-1.9273 1.2091-3.9929 1.2091-6.0789s-.4108-4.1516-1.2091-6.07889c-.7983-1.92723-1.9684-3.67837-3.4434-5.15341-1.4751-1.47504-3.2262-2.64511-5.1534-3.4434-1.9273-.79829-3.9929-1.20916283-6.0789-1.20916264v15.88486264z",
    fill: "#00d563"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m.256348 56.6096h16.397252v-23.5588c-9.05595 0-16.397252 7.3413-16.397252 16.3972z",
    fill: "#00d563"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#12c6a0"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.19863,
    cy: 8.19863,
    r: 8.19863
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.6952,
    cy: 48.8012,
    r: 8.19863
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.6652801c9c05dbdb95266d83125c5e90.svg";
export { ForwardRef as ReactComponent };